var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup29(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 186.443,
    height: 159.462,
    viewBox: "0 0 186.443 159.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-1384.093 -1311.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M2454.158,332.438V443.352H2471.2a11.72,11.72,0,0,1,11.71,11.71v15.724h29.239V443.574a4.349,4.349,0,0,1,4.349-4.361h14.362v31.573h5.167V439.213h14.348a4.361,4.361,0,0,1,4.363,4.361v27.212h48.74v-7.321a12.123,12.123,0,0,1-2.041-19.085,9.766,9.766,0,0,1-1.529-5.264,9.92,9.92,0,0,1,12.809-9.488v-97.19Zm43.588,79.675a3.876,3.876,0,0,1-3.875,3.875h-15.2a3.877,3.877,0,0,1-3.877-3.875v-21a3.878,3.878,0,0,1,3.877-3.876h15.2a3.877,3.877,0,0,1,3.875,3.876Zm0-40.046a3.876,3.876,0,0,1-3.875,3.875h-15.2a3.877,3.877,0,0,1-3.877-3.875v-21a3.878,3.878,0,0,1,3.877-3.876h15.2a3.877,3.877,0,0,1,3.875,3.876Zm24.225-21a3.878,3.878,0,0,1,3.875-3.876h15.2a3.878,3.878,0,0,1,3.876,3.876v21a3.877,3.877,0,0,1-3.876,3.875h-15.2a3.877,3.877,0,0,1-3.875-3.875Zm28.684,83.2H2516.22c-2.263,0-3.959-1.792-3.513-3.681,1.985-8.279,10.514-14.488,20.737-14.488s18.738,6.209,20.724,14.488c.459,1.889-1.25,3.681-3.513,3.681m41.42-22.155a3.876,3.876,0,0,1-3.875,3.875h-15.181a3.868,3.868,0,0,1-3.877-3.875v-21a3.869,3.869,0,0,1,3.877-3.876H2588.2a3.877,3.877,0,0,1,3.875,3.876Zm0-40.046a3.876,3.876,0,0,1-3.875,3.875h-15.181a3.868,3.868,0,0,1-3.877-3.875v-21a3.869,3.869,0,0,1,3.877-3.876H2588.2a3.877,3.877,0,0,1,3.875,3.876Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M2621.093,327.312H2445.782c-5.222,0-7.555-5.348-3.513-8.056l10.264-6.9a6.371,6.371,0,0,1,3.529-1.028h154.766a6.332,6.332,0,0,1,3.515,1.028l10.278,6.9c4.027,2.708,1.694,8.056-3.528,8.056",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M2478.022,455.062v15.724h-30.767V455.062a6.823,6.823,0,0,1,6.82-6.82H2471.2a6.823,6.823,0,0,1,6.821,6.82",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M2612.717,464.91v5.876h-5.765v-5.862a12.276,12.276,0,0,0,2.876.347,11.693,11.693,0,0,0,2.889-.361",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M2619.523,453.131a9.614,9.614,0,0,1-3.334,7.306,8.382,8.382,0,0,1-1.736,1.223,11.372,11.372,0,0,1-1.736.736,9.962,9.962,0,0,1-2.89.43,9.86,9.86,0,0,1-2.875-.43,10.169,10.169,0,0,1-1.737-.736,8.937,8.937,0,0,1-1.736-1.209,9.7,9.7,0,0,1-.486-14.182,9.748,9.748,0,0,0,6.834,2.764,9.962,9.962,0,0,0,2.89-.43,9.674,9.674,0,0,0,3.958-2.334,9.634,9.634,0,0,1,2.848,6.862",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M2617.314,439.115a7.261,7.261,0,0,1-1.027,3.764,6.659,6.659,0,0,1-.681,1,7.716,7.716,0,0,1-.889.9,7.33,7.33,0,0,1-4.889,1.82,7.3,7.3,0,0,1-4.876-1.834,6.673,6.673,0,0,1-.889-.889,8.022,8.022,0,0,1-.694-1,7.375,7.375,0,0,1-1.014-3.764,7.475,7.475,0,0,1,7.473-7.473,7.64,7.64,0,0,1,2.889.57,7.491,7.491,0,0,1,4.6,6.9",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup29);
export default __webpack_public_path__ + "static/media/Group 29.2522c0cfe9baf1f1479014f6a0b4fb33.svg";
export { ForwardRef as ReactComponent };